const avatarImage = 'assets/img/avtar.png';
const pickleball = 'assets/img/pickleball.svg';
const italogo = 'assets/img/ita-logo.png';
const intennseAd = 'assets/img/intennse-ad.png';
const mlp = 'assets/img/mlp.png';
const ioncourt = 'assets/img/logo-60-darkmode.png';
const logoSquare = 'assets/img/logo/ioncourt/logo-square.png';
const badminton = 'assets/img/badminton.svg';

export const images = { 
    avatarImage: avatarImage,
    pickleball: pickleball,
    italogo: italogo,
    intennseAd: intennseAd,
    mlp: mlp,
    ioncourt: ioncourt,
    logoSquare: logoSquare,
    badminton: badminton
};
